var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,style:(_vm.styleObject),attrs:{"id":_vm.id,"pieData":_vm.pieData}})
}
var staticRenderFns = []

export { render, staticRenderFns }